/**
 * Navigation History Manager
 * Tracks the last non-product page URL and uses it to replace history
 * when landing on product pages, ensuring back button returns to the
 * last non-product page instead of cycling through product pages.
 */

class NavigationHistoryManager {
  constructor() {
    this.STORAGE_KEY = 'lastNonProductUrl';
    this.init();
  }

  init() {
    this.handlePage();
  }

  /**
   * Handle the current page
   * - On non-product pages: store the current URL
   * - On product pages: use stored URL to replace previous history entry
   */
  handlePage() {
    const pathname = window.location.pathname;
    const currentPage = window.location.href;
    const isProductPage = pathname.includes('/products/');

    if (!isProductPage) {
      // Store current URL as the last non-product page
      sessionStorage.setItem(this.STORAGE_KEY, currentPage);
    } else {
      // On product page, replace the previous history entry with the last non-product URL
      const lastNonProductUrl = sessionStorage.getItem(this.STORAGE_KEY);
      if (lastNonProductUrl) {
        window.history.replaceState(
          {
            navigationManaged: true,
            timestamp: Date.now()
          },
          '',
          lastNonProductUrl
        );

        // Push the current product URL so the address bar shows the correct URL
        window.history.pushState(
          {
            navigationManaged: true,
            productPage: true,
            timestamp: Date.now()
          },
          '',
          currentPage
        );
      }
    }
  }
}

// Initialize on DOM ready with error handling
try {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      try {
        window.navigationHistoryManager = new NavigationHistoryManager();
      } catch (error) {
        console.error('Failed to initialize NavigationHistoryManager:', error);
      }
    });
  } else {
    window.navigationHistoryManager = new NavigationHistoryManager();
  }
} catch (error) {
  console.error('Failed to initialize NavigationHistoryManager:', error);
}
